import { render, staticRenderFns } from "./ProductConfigurator.vue?vue&type=template&id=5fa971c7&scoped=true&"
import script from "./ProductConfigurator.vue?vue&type=script&lang=js&"
export * from "./ProductConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./ProductConfigurator.vue?vue&type=style&index=0&id=5fa971c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa971c7",
  null
  
)

export default component.exports